import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { IDescriptionListData } from "@at/design-system-patterns";
import { useQuery } from "@at/sauron-platform-graphql";

import {
  LeasingVehicleSummaryListQuery,
  LeasingVehicleSummaryListQueryVariables,
} from "./query/__generated__/leasing-vehicle-summary-list.query";
import { leasingVehicleSummaryListQuery } from "./query/leasing-vehicle-summary-list.query";
import { VehicleSummaryList } from "../../components/vehicle-summary-list/vehicle-summary-list";
import { ProductPageVariables } from "../../pages/leasing/leasing-product-page-content.types";
import { buildStateFromRequest } from "../../utils/leasing/state/state-utils";

const detailsAsString = (details: unknown) => (details ?? "") as string;

export const LeasingVehicleSummaryList = () => {
  const location = useLocation();
  const { advertId } = useParams<ProductPageVariables>();
  const { leaseOption } = buildStateFromRequest(location.search, "PRODUCT");
  const shouldSkipQuery = !leaseOption || !advertId;

  const { data, error } = useQuery<
    LeasingVehicleSummaryListQuery,
    LeasingVehicleSummaryListQueryVariables
  >(leasingVehicleSummaryListQuery, {
    errorPolicy: "all",
    variables: {
      advertId,
      leaseOption,
    },
    skip: shouldSkipQuery,
  });

  const advertData = data?.search.advert.specification;
  const batteryRange = advertData?.battery?.range?.range;
  const hasBatteryRange = advertData?.battery?.range?.range != null;

  const items: IDescriptionListData[] = [
    {
      term: "Fuel type",
      details: detailsAsString(advertData?.fuel),
    },
    {
      term: "Bodytype",
      details: detailsAsString(advertData?.bodyType),
    },
    {
      term: "Range",
      details: hasBatteryRange ? `${detailsAsString(batteryRange)} miles` : "",
    },
    {
      term: "Gearbox",
      details: detailsAsString(advertData?.transmission),
    },
    {
      term: "Doors",
      details: detailsAsString(advertData?.doors ?? ""),
    },
    {
      term: "Seats",
      details: detailsAsString(advertData?.seats ?? ""),
    },
  ].filter(({ details }) => details !== "");

  const nothingToShow = error || (items && items.length === 0);

  if (nothingToShow) return null;

  return <VehicleSummaryList data={items} />;
};
